module.exports = __webpack_public_path__ + "static/media/PDF_117.e7e7270c.pdf";